module.exports = __webpack_public_path__ + "images/agriculture-logo-dark.svg";